"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableMixin = exports.getMixinDeclarations = exports.applyMixin = exports.removeMixin = exports.buildMixin = exports.parseMixinValue = void 0;
var tslib_1 = require("tslib");
var postcss = tslib_1.__importStar(require("postcss"));
var core_1 = require("@stylable/core");
var parseMixinValue = function (value) { return (value ? value.split(',').map(function (name) { return name.trim(); }) : []); };
exports.parseMixinValue = parseMixinValue;
var buildMixin = function (mixins) { return mixins.join(', ') || undefined; };
exports.buildMixin = buildMixin;
function removeMixin(name, mixins) {
    if (!mixins) {
        return undefined;
    }
    var mixinList = exports.parseMixinValue(mixins);
    var nameIndex = mixinList.findIndex(function (mixin) { return mixin === name; });
    if (nameIndex !== -1) {
        mixinList.splice(nameIndex, 1);
    }
    return exports.buildMixin(mixinList);
}
exports.removeMixin = removeMixin;
function applyMixin(name, mixins) {
    if (!mixins) {
        return "" + name;
    }
    var mixinList = exports.parseMixinValue(removeMixin(name, mixins));
    mixinList.push(name);
    return exports.buildMixin(mixinList);
}
exports.applyMixin = applyMixin;
function getMixinDeclarations(sheet, name) {
    var mixinSubset = core_1.createSubsetAst(sheet.AST, "." + name);
    if (!mixinSubset.nodes || mixinSubset.nodes.length === 0) {
        return [];
    }
    return mixinSubset.nodes[0].nodes || []; // TODO: eval all values here or in controller?
}
exports.getMixinDeclarations = getMixinDeclarations;
var StylableMixin = /** @class */ (function () {
    function StylableMixin(sheet) {
        this.sheet = sheet;
    }
    // TODO: Get from Stylable
    StylableMixin.prototype.applyMixin = function (rule, mixinName) {
        var mixinDecl = this.getMixinDeclaration(rule);
        if (!mixinDecl) {
            rule.append(postcss.decl({ prop: core_1.valueMapping.mixin, value: mixinName }));
        }
        else {
            if (!~mixinDecl.value.indexOf(mixinName)) {
                mixinDecl.value = mixinDecl.value + ", " + mixinName;
            }
        }
        mixinDecl && this.writeAST(mixinDecl);
    };
    // TODO: Get from Stylable
    StylableMixin.prototype.removeMixin = function (rule, mixinName) {
        var mixinDecl = this.getMixinDeclaration(rule);
        if (!mixinDecl) {
            return;
        }
        mixinDecl.value = mixinDecl.value.replace(new RegExp("\\s*,*\\s*" + mixinName + "\\s*"), '').trim();
        if (!mixinDecl.value) {
            rule.removeChild(mixinDecl);
            this.writeAST(rule);
        }
        else {
            this.writeAST(mixinDecl);
        }
    };
    StylableMixin.prototype.writeAST = function (modified) {
        this.sheet.updateFromAST(modified);
    };
    StylableMixin.prototype.getMixinDeclaration = function (rule) {
        var declarations = [];
        rule.walkDecls(function (decl) {
            declarations.push(decl);
        });
        if (!declarations.length) {
            return null;
        }
        declarations.reverse();
        return declarations.find(function (decl) { return decl.prop === core_1.valueMapping.mixin; }) || null;
    };
    return StylableMixin;
}());
exports.StylableMixin = StylableMixin;
//# sourceMappingURL=stylable-mixin.js.map